import { PropTypes } from 'prop-types';
import React from 'react';
import { AddCreditMemoDrawer } from '~/modules/billing-invoicing/creditMemo/components';
import { useProjectReference } from '~/modules/billing-invoicing/common/hooks';

export const AssignNewCreditMemoDrawer = ({
  billId,
  open,
  onClose,
  client,
  billBalanceTotal,
  queryParams
}) => {
  const projectSlug = queryParams ? queryParams.get('projectSlug') : null;
  const { projectUri, projectName } = useProjectReference({
    projectSlug
  });

  return (
    <AddCreditMemoDrawer
      open={open}
      onClose={onClose}
      projectUri={projectUri}
      projectName={projectName}
      client={client}
      billId={billId}
      billBalanceTotal={billBalanceTotal}
      showAllBills={false}
    />
  );
};

AssignNewCreditMemoDrawer.propTypes = {
  billId: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  client: PropTypes.object,
  billBalanceTotal: PropTypes.object,
  queryParams: PropTypes.object
};

export default AssignNewCreditMemoDrawer;
